import { Field, TextEditor } from '@approvalmax/ui';
import { Flex } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import { changeQbooksCustomField } from 'pages/requestForm/actions';
import { SectionContainer } from 'pages/requestForm/components/SectionContainer';
import { getContext, getRequest } from 'pages/requestForm/selectors/pageSelectors';
import { memo, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { messages } from './SalesInvoiceCustomFields.messages';

export const SalesInvoiceCustomFields = memo(() => {
    const dispatch = useDispatch();
    const context = useSelector(getContext);
    const request = useSelector<domain.QBooksInvoiceRequest>(getRequest);
    const {
        details: { customFields },
    } = request;

    const fields = useMemo(
        () =>
            context.fields.filter(
                ({ systemPurpose }) => systemPurpose === domain.FieldSystemPurpose.QBooksInvoiceCustom
            ),
        [context.fields]
    );

    if (!fields.length) {
        return null;
    }

    return (
        <SectionContainer>
            <Flex container spacing='0 20'>
                {fields.map(({ id, text }) => {
                    const fieldValue = customFields.find(({ field }) => field.id === id);

                    return (
                        <Flex size={6} key={id} block>
                            <Field title={text}>
                                <TextEditor
                                    qa={text}
                                    value={fieldValue?.value ?? ''}
                                    onChange={(newValue) => dispatch(changeQbooksCustomField(id, newValue))}
                                    placeholder={messages.customFieldPlaceholder}
                                    changeOnBlur
                                />
                            </Field>
                        </Flex>
                    );
                })}
            </Flex>
        </SectionContainer>
    );
});

SalesInvoiceCustomFields.displayName = 'SalesInvoiceCustomFields';
